import { apiFetch } from "./client";

export function listCookieAccounts() {
  return apiFetch("/api/cookies");
}


export function addCookieAccountAuto(values) {
  return apiFetch("/api/cookies/accounts/auto", {
    method: "POST",
    body: { values },
  });
}

export function deleteCookieAccount(account) {
  return apiFetch(`/api/cookies/accounts/${account}`, { method: "DELETE" });
}

export function upsertCookie(account, cookie) {
  return apiFetch(`/api/cookies/accounts/${account}/cookies`, {
    method: "PUT",
    body: cookie, // {name,value,domain,path}
  });
}

export function deleteCookie(account, name) {
  return apiFetch(`/api/cookies/accounts/${account}/cookies/${encodeURIComponent(name)}`, {
    method: "DELETE",
  });
}

export function cleanupCookies() {
  return apiFetch("/api/cookies/cleanup", { method: "POST" });
}
